import { ComboBoxParam, SonForm, TextParam } from '../../_lib/Form2';
import { ICategory } from '../../types/ICategory';

export type CalendarEditableElement = {
  id: string;
  calendarTitle: string;
  edit: SonForm<TextParam<'title'> | ComboBoxParam<'targetCalendarId'>>;
  delete: SonForm<any>;
};

export type EventType = {
  date: string;
  title: string;
  url: string;
  categories?: ICategory[];
};

export type CalendarDayInfoType = {
  day: number;
  eventsCount: number;
  date: string;
  isCurrentMonth: boolean;
  isCurrentDay: boolean;
};

export enum WeekDayType {
  MON = 'Mon',
  TUE = 'Tue',
  WED = 'Wed',
  THU = 'Thu',
  FRI = 'Fri',
  SAT = 'Sat',
  SUN = 'Sun',
}

export enum WeekDayAbbrType {
  MON = 'mon',
  TUE = 'tue',
  WED = 'wed',
  THU = 'thu',
  FRI = 'fri',
  SAT = 'sat',
  SUN = 'sun',
}

export enum Months {
  JAN = 'jan',
  FEB = 'feb',
  MAR = 'mar',
  APR = 'apr',
  MAY = 'may',
  JUNE = 'june',
  JULY = 'july',
  AUG = 'aug',
  SEP = 'sept',
  OCT = 'oct',
  NOV = 'nov',
  DEC = 'dec',
}

export type CalendarForm = SonForm<TextParam<'title'> | ComboBoxParam<'targetCalendarId'>>;
